const e = {
  undo: "Undo",
  redo: "Redo",
  confirm: "Confirm",
  clear: "Clear",
  more: "more",
  cancel: "Cancel",
  update: "Update"
}, t = {
  positiveText: "Confirm",
  negativeText: "Cancel"
}, a = {
  placeholder: "Please Select",
  loading: "Loading"
}, o = {
  clear: "Clear",
  now: "Now",
  confirm: "Confirm",
  selectTime: "Select Time",
  selectDate: "Select Date",
  datePlaceholder: "Select Date",
  datetimePlaceholder: "Select Date and Time",
  monthPlaceholder: "Select Month",
  yearPlaceholder: "Select Year",
  quarterPlaceholder: "Select Quarter",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",
  startDatetimePlaceholder: "Start Date and Time",
  endDatetimePlaceholder: "End Date and Time",
  startMonthPlaceholder: "Start Month",
  endMonthPlaceholder: "End Month",
  today: "Today"
}, l = {
  checkTableAll: "Select all in the table",
  uncheckTableAll: "Unselect all in the table",
  confirm: "Confirm",
  clear: "Clear",
  apply: "Apply",
  filters: "Filters",
  sort: "Sort"
}, r = {
  sourceTitle: "Source",
  targetTitle: "Target"
}, n = {
  selectAll: "Select all",
  unselectAll: "Unselect all",
  clearAll: "Clear"
}, c = {
  description: "No Data"
}, i = {
  placeholder: "Please Select"
}, d = {
  placeholder: "Select Time",
  positiveText: "OK",
  negativeText: "Cancel",
  now: "Now"
}, s = {
  goto: "Goto",
  selectionSuffix: "page",
  next: "Next",
  previous: "Previous"
}, p = {
  add: "Add"
}, m = {
  loading: "Loading"
}, u = {
  placeholder: "Please Input"
}, g = {
  placeholder: "Please Input"
}, C = {
  create: "Create"
}, h = {
  title: "Theme Editor",
  clearAllVars: "Clear All Variables",
  clearSearch: "Clear Search",
  filterCompName: "Filter Component Name",
  filterVarName: "Filter Variable Name",
  import: "Import",
  export: "Export",
  restore: "Reset to Default"
}, P = {
  tipPrevious: "Previous picture (←)",
  tipNext: "Next picture (→)",
  tipCounterclockwise: "Counterclockwise",
  tipClockwise: "Clockwise",
  tipZoomOut: "Zoom out",
  tipZoomIn: "Zoom in",
  tipClose: "Close (Esc)",
  tipOriginalSize: "Zoom to original size"
}, S = {
  heading: "Sort and Filters",
  sortHeading: "Sort By",
  newestFirst: "Newest First",
  oldestFirst: "Oldest First",
  ascending: "Asc",
  descending: "Desc",
  apply: "Apply",
  clear: "Clear",
  cancel: "Cancel",
  filters: "Filters"
}, T = {
  noMatchingFound: "No matching results found"
}, f = {
  margin: "Margin",
  padding: "Padding",
  reset: "Reset",
  errorMsg: "Provided value is invalid."
}, D = {
  brandColors: "Brand Colors",
  noBrandColors: "You do not have any brand colors added yet.",
  getStarted: "Get Started",
  add: "Add",
  default: "Default"
}, y = {
  addColor: "Add New Color",
  editColor: "Edit Color",
  add: "Add",
  noData: "You do not have any colors added yet.",
  invalidCode: "Invalid color code",
  defaultColor: "Default Colors"
}, v = {
  global: e,
  Popconfirm: t,
  Cascader: a,
  DatePicker: o,
  DataTable: l,
  LegacyTransfer: r,
  Transfer: n,
  Empty: c,
  Select: i,
  TimePicker: d,
  Pagination: s,
  DynamicTags: p,
  Log: m,
  Input: u,
  InputNumber: g,
  DynamicInput: C,
  ThemeEditor: h,
  Image: P,
  SortFilter: S,
  IconPicker: T,
  Spacing: f,
  BrandColorPicker: D,
  BrandBoard: y
};
export {
  y as BrandBoard,
  D as BrandColorPicker,
  a as Cascader,
  l as DataTable,
  o as DatePicker,
  C as DynamicInput,
  p as DynamicTags,
  c as Empty,
  T as IconPicker,
  P as Image,
  u as Input,
  g as InputNumber,
  r as LegacyTransfer,
  m as Log,
  s as Pagination,
  t as Popconfirm,
  i as Select,
  S as SortFilter,
  f as Spacing,
  h as ThemeEditor,
  d as TimePicker,
  n as Transfer,
  v as default,
  e as global
};
